function ReservationIcon(props) {
  return (
    <svg
      width={32}
      height={32}
      fill="#A8ADB2"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M21 15h-5v5h5v-5zM20 4v2h-8V4h-2v2H9c-1.11 0-1.99.9-1.99 2L7 22a2 2 0 002 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-1V4h-2zm3 18H9V11h14v11z" />
    </svg>
  )
}

export default ReservationIcon
